import { render, staticRenderFns } from "./step-3.vue?vue&type=template&id=2a447102&scoped=true&"
import script from "./step-3.vue?vue&type=script&lang=js&"
export * from "./step-3.vue?vue&type=script&lang=js&"
import style0 from "./step-3.vue?vue&type=style&index=0&id=2a447102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a447102",
  null
  
)

export default component.exports